import * as yup from "yup";
import { number, object, string } from "yup";

export const NewProcedureValidation = yup.object().shape({
	ProjectGroup: yup.number().min(0, "Please choose a group.").required(),
	Name: yup.string().required(),
	Responsible: object({
		Id: number().required(
			"Cannot create a procedure without any organization members",
		),
		Name: string().required(),
	}),
});
